import script from "./BaseChartElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseChartElement.vue?vue&type=script&lang=ts&setup=true"

import "./BaseChartElement.vue?vue&type=style&index=0&id=7c03d68d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c03d68d"]])

export default __exports__